module.exports = __webpack_public_path__ + "static/img/teach1.4f3d569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upiTeaching/teach1.png
// module id = Ha6g
// module chunks = 0